import axios from 'axios';

/*
  **************************************************************************
  api 全局配置
  **************************************************************************
*/

let httpHandler = {
    post: axios.defaults.headers.post['Content-Type'] = 'application/json; charset = UTF-8',
    put: axios.defaults.headers.put['Content-Type'] = 'application/json; charset = UTF-8',
    delete: axios.defaults.headers.delete['Content-Type'] = 'application/json; charset = UTF-8',
};

// let urls = 'https://anystage.com.cn/api/'; // 服务器
let urls = 'http://39.99.151.131:2000/'; // 服务器
// let urls = 'http://127.0.0.1:2000'; // 本地

export default {
    postHttp(url, data, headers) {
        console.log('postHttpData----->', data);
        return axios({
            url: urls + url,
            method: 'POST',
            data: data,
            headers: headers
        });
    },
    getHttp(url, headers) {
        return axios({
            url: urls + url,
            method: 'GET',
            headers: headers
        });
    },
    putHttp(url, data, header) {
        return axios({
            url: urls + url,
            method: 'PUT',
            data: data,
            headers: header
        });
    },
    deleteHttp(url, data, header) {
        return axios({
            url: urls + url,
            method: 'DELETE',
            data: data,
            headers: header
        });
    }
};





// WEBPACK FOOTER //
// ./src/api/index.js